import { random } from "lodash";
export function rollTreasure(roll = random(1, 18)) {
    // TODO: Scan the treasures table
    return "treasure";
}
